// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrder\ApiPilotJobOrder.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { ApprovalOfCharges, ApprovalOfChargesData, ApprovalOfChargesOptions } from 'data/models/ApprovalOfCharges';
import { BillCoverage, BillCoverageData, BillCoverageOptions } from 'data/models/BillCoverage';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { Issue, IssueData, IssueOptions } from 'data/models/Issue';
import { ItineraryPoint, ItineraryPointData, ItineraryPointOptions } from 'data/models/ItineraryPoint';
import { JobOrder, JobOrderData, JobOrderOptions } from 'data/models/JobOrder';
import { JobOrderSelf, JobOrderSelfData, JobOrderSelfOptions } from 'data/models/JobOrderSelf';
import { LineHandlingCompany, LineHandlingCompanyData, LineHandlingCompanyOptions } from 'data/models/LineHandlingCompany';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';
import { PilotAgency, PilotAgencyData, PilotAgencyOptions } from 'data/models/PilotAgency';
import { PilotAssignment, PilotAssignmentData, PilotAssignmentOptions } from 'data/models/PilotAssignment';
import { PilotJobOrderCancellation, PilotJobOrderCancellationData, PilotJobOrderCancellationOptions } from 'data/models/PilotJobOrderCancellation';
import { PilotJobOrderChange, PilotJobOrderChangeData, PilotJobOrderChangeOptions } from 'data/models/PilotJobOrderChange';
import { PilotJobOrderRelevance, PilotJobOrderRelevanceData, PilotJobOrderRelevanceOptions } from 'data/models/PilotJobOrderRelevance';
import { PilotJobOrderUserPreferences, PilotJobOrderUserPreferencesData, PilotJobOrderUserPreferencesOptions } from 'data/models/PilotJobOrderUserPreferences';
import { PilotJobOrderVersion, PilotJobOrderVersionData, PilotJobOrderVersionOptions } from 'data/models/PilotJobOrderVersion';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { QuickBooksJobTracking, QuickBooksJobTrackingData, QuickBooksJobTrackingOptions } from 'data/models/QuickBooksJobTracking';
import { ScheduleDate, ScheduleDateData, ScheduleDateOptions } from 'data/models/ScheduleDate';
import { ScheduleDateEntity, ScheduleDateEntityData, ScheduleDateEntityOptions } from 'data/models/ScheduleDateEntity';
import { TugCompany, TugCompanyData, TugCompanyOptions } from 'data/models/TugCompany';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';

// PilotJobOrderData is the class that PilotJobOrder serializes to/from
export interface PilotJobOrderData {
    Id : number;
    Url : string | null;
	
    _approvalsOfCharges : ApprovalOfChargesData[] | null;
    Bills : BillCoverageData[] | null;
    Cancellation : PilotJobOrderCancellationData | null;
    Change : ChangeData | null;
    ChangeId : number;
    Changes : PilotJobOrderChangeData[] | null;
    FromPoint : ItineraryPointData | null;
    FromPointId : number;
    Issues : IssueData[] | null;
    JobOrder : JobOrderData | null;
    LineHandlingCompany : LineHandlingCompanyData | null;
    LineHandlingCompanyId : number | null;
    Log : PilotJobOrderRelevanceData[] | null;
    PilotAgency : PilotAgencyData | null;
    PilotAgencyId : number;
    Pilots : PilotAssignmentData[] | null;
    PortCall : PortCallData | null;
    PortCallId : number;
    Schedule : ScheduleDateEntityData[] | null;
    Self : JobOrderSelfData | null;
    ToPoint : ItineraryPointData | null;
    ToPointId : number;
    TugCompany : TugCompanyData | null;
    TugCompanyId : number | null;
    UserPreferences : PilotJobOrderUserPreferencesData[] | null;
    Version : PilotJobOrderVersionData | null;
    Vessel : VesselData | null;
    VesselId : number | null;
	
    AcknowledgedDate : /* ISO8601 */ string | null;
    AirDraft : NullableMeasurementData;
    Billable : boolean;
    BillToAddress : string | null;
    BillToAgent : boolean;
    BowThrusterOperational : boolean | null;
    DeepDraft : NullableMeasurementData;
    DeepDraftConfirmed : boolean;
    End : ScheduleDateData;
    Guid : /* GUID */ string;
    LaborStartTime : /* ISO8601 */ string | null;
    Length : NullableMeasurementData;
    NumberOfTugs : number;
    PilotsUrlBase : string | null;
    QBTracking : QuickBooksJobTrackingData;
    Remarks : string | null;
    Start : ScheduleDateData;
    StartTimeConfirmed : boolean;
    UserPreferencesUrlBase : string | null;
}

// PilotJobOrderOptions is the class which may be passed to the PilotJobOrder constructor to define optional initial data values
export interface PilotJobOrderOptions {
    Id : number;
    Url? : string | null;
	
    _approvalsOfCharges? : ApprovalOfChargesOptions[] | null;
    Bills? : BillCoverageOptions[] | null;
    Cancellation? : PilotJobOrderCancellationOptions | null;
    Change? : ChangeOptions | null;
    ChangeId? : number;
    Changes? : PilotJobOrderChangeOptions[] | null;
    FromPoint? : ItineraryPointOptions | null;
    FromPointId? : number;
    Issues? : IssueOptions[] | null;
    JobOrder? : JobOrderOptions | null;
    LineHandlingCompany? : LineHandlingCompanyOptions | null;
    LineHandlingCompanyId? : number | null;
    Log? : PilotJobOrderRelevanceOptions[] | null;
    PilotAgency? : PilotAgencyOptions | null;
    PilotAgencyId? : number;
    Pilots? : PilotAssignmentOptions[] | null;
    PortCall? : PortCallOptions | null;
    PortCallId? : number;
    Schedule? : ScheduleDateEntityOptions[] | null;
    Self? : JobOrderSelfOptions | null;
    ToPoint? : ItineraryPointOptions | null;
    ToPointId? : number;
    TugCompany? : TugCompanyOptions | null;
    TugCompanyId? : number | null;
    UserPreferences? : PilotJobOrderUserPreferencesOptions[] | null;
    Version? : PilotJobOrderVersionOptions | null;
    Vessel? : VesselOptions | null;
    VesselId? : number | null;
	
    AcknowledgedDate? : /* ISO8601 */ string | null;
    AirDraft? : NullableMeasurementOptions;
    Billable? : boolean;
    BillToAddress? : string | null;
    BillToAgent? : boolean;
    BowThrusterOperational? : boolean | null;
    DeepDraft? : NullableMeasurementOptions;
    DeepDraftConfirmed? : boolean;
    End? : ScheduleDateOptions;
    Guid? : /* GUID */ string;
    LaborStartTime? : /* ISO8601 */ string | null;
    Length? : NullableMeasurementOptions;
    NumberOfTugs? : number;
    PilotsUrlBase? : string | null;
    QBTracking? : QuickBooksJobTrackingOptions;
    Remarks? : string | null;
    Start? : ScheduleDateOptions;
    StartTimeConfirmed? : boolean;
    UserPreferencesUrlBase? : string | null;
}

export class PilotJobOrder {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public _approvalsOfCharges : SDataArray<ApprovalOfCharges>;
    public Bills : SDataArray<BillCoverage>;
    public Cancellation : DataSignal<PilotJobOrderCancellation | null>;
    public Change : DataSignal<Change | null>;
    public ChangeId : DataSignal<number>;
    public Changes : SDataArray<PilotJobOrderChange>;
    public FromPoint : DataSignal<ItineraryPoint | null>;
    public FromPointId : DataSignal<number>;
    public Issues : SDataArray<Issue>;
    public JobOrder : DataSignal<JobOrder | null>;
    public LineHandlingCompany : DataSignal<LineHandlingCompany | null>;
    public LineHandlingCompanyId : DataSignal<number | null>;
    public Log : SDataArray<PilotJobOrderRelevance>;
    public PilotAgency : DataSignal<PilotAgency | null>;
    public PilotAgencyId : DataSignal<number>;
    public Pilots : SDataArray<PilotAssignment>;
    public PortCall : DataSignal<PortCall | null>;
    public PortCallId : DataSignal<number>;
    public Schedule : SDataArray<ScheduleDateEntity>;
    public Self : DataSignal<JobOrderSelf | null>;
    public ToPoint : DataSignal<ItineraryPoint | null>;
    public ToPointId : DataSignal<number>;
    public TugCompany : DataSignal<TugCompany | null>;
    public TugCompanyId : DataSignal<number | null>;
    public UserPreferences : SDataArray<PilotJobOrderUserPreferences>;
    public Version : DataSignal<PilotJobOrderVersion | null>;
    public Vessel : DataSignal<Vessel | null>;
    public VesselId : DataSignal<number | null>;
	
    public AcknowledgedDate : DataSignal<TZDate | null>;
    public AirDraft : NullableMeasurement;
    public Billable : DataSignal<boolean>;
    public BillToAddress : DataSignal<string | null>;
    public BillToAgent : DataSignal<boolean>;
    public BowThrusterOperational : DataSignal<boolean | null>;
    public DeepDraft : NullableMeasurement;
    public DeepDraftConfirmed : DataSignal<boolean>;
    public End : ScheduleDate;
    public Guid : DataSignal<string>;
    public LaborStartTime : DataSignal<TZDate | null>;
    public Length : NullableMeasurement;
    public NumberOfTugs : DataSignal<number>;
    public PilotsUrlBase : DataSignal<string | null>;
    public QBTracking : QuickBooksJobTracking;
    public Remarks : DataSignal<string | null>;
    public Start : ScheduleDate;
    public StartTimeConfirmed : DataSignal<boolean>;
    public UserPreferencesUrlBase : DataSignal<string | null>;

    constructor();
    constructor(data : PilotJobOrderOptions);
    constructor(data: PilotJobOrderOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this._approvalsOfCharges = SArray<ApprovalOfCharges>([]);
        this.Bills = SArray<BillCoverage>([]);
        this.Cancellation = S.value<PilotJobOrderCancellation | null>(null);
        this.Change = S.value<Change | null>(null);
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Changes = SArray<PilotJobOrderChange>([]);
        this.FromPoint = S.value<ItineraryPoint | null>(null);
        this.FromPointId = jsonableObservable(S.value<number>(data && data.FromPointId !== undefined ? data.FromPointId : 0));
        this.Issues = SArray<Issue>([]);
        this.JobOrder = S.value<JobOrder | null>(null);
        this.LineHandlingCompany = S.value<LineHandlingCompany | null>(null);
        this.LineHandlingCompanyId = jsonableObservable(S.value<number | null>(data && data.LineHandlingCompanyId !== undefined ? data.LineHandlingCompanyId : null));
        this.Log = SArray<PilotJobOrderRelevance>([]);
        this.PilotAgency = S.value<PilotAgency | null>(null);
        this.PilotAgencyId = jsonableObservable(S.value<number>(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.Pilots = SArray<PilotAssignment>([]);
        this.PortCall = S.value<PortCall | null>(null);
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.Schedule = SArray<ScheduleDateEntity>([]);
        this.Self = S.value<JobOrderSelf | null>(null);
        this.ToPoint = S.value<ItineraryPoint | null>(null);
        this.ToPointId = jsonableObservable(S.value<number>(data && data.ToPointId !== undefined ? data.ToPointId : 0));
        this.TugCompany = S.value<TugCompany | null>(null);
        this.TugCompanyId = jsonableObservable(S.value<number | null>(data && data.TugCompanyId !== undefined ? data.TugCompanyId : null));
        this.UserPreferences = SArray<PilotJobOrderUserPreferences>([]);
        this.Version = S.value<PilotJobOrderVersion | null>(null);
        this.Vessel = S.value<Vessel | null>(null);
        this.VesselId = jsonableObservable(S.value<number | null>(data && data.VesselId !== undefined ? data.VesselId : null));
	    
        this.AcknowledgedDate = jsonableObservable(S.value<TZDate | null>(data && data.AcknowledgedDate !== undefined ? data.AcknowledgedDate === null ? null : new TZDate(data.AcknowledgedDate) : null, TZDate.nullableEq));
        this.AirDraft = data && data.AirDraft !== undefined ? new NullableMeasurement(data.AirDraft) : new NullableMeasurement();
        this.Billable = jsonableObservable(S.value<boolean>(data && data.Billable !== undefined ? data.Billable : false));
        this.BillToAddress = jsonableObservable(S.value<string | null>(data && data.BillToAddress !== undefined ? data.BillToAddress : null));
        this.BillToAgent = jsonableObservable(S.value<boolean>(data && data.BillToAgent !== undefined ? data.BillToAgent : false));
        this.BowThrusterOperational = jsonableObservable(S.value<boolean | null>(data && data.BowThrusterOperational !== undefined ? data.BowThrusterOperational : null));
        this.DeepDraft = data && data.DeepDraft !== undefined ? new NullableMeasurement(data.DeepDraft) : new NullableMeasurement();
        this.DeepDraftConfirmed = jsonableObservable(S.value<boolean>(data && data.DeepDraftConfirmed !== undefined ? data.DeepDraftConfirmed : false));
        this.End = data && data.End !== undefined ? new ScheduleDate(data.End) : new ScheduleDate();
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.LaborStartTime = jsonableObservable(S.value<TZDate | null>(data && data.LaborStartTime !== undefined ? data.LaborStartTime === null ? null : new TZDate(data.LaborStartTime) : null, TZDate.nullableEq));
        this.Length = data && data.Length !== undefined ? new NullableMeasurement(data.Length) : new NullableMeasurement();
        this.NumberOfTugs = jsonableObservable(S.value<number>(data && data.NumberOfTugs !== undefined ? data.NumberOfTugs : 0));
        this.PilotsUrlBase = jsonableObservable(S.value<string | null>(data && data.PilotsUrlBase !== undefined ? data.PilotsUrlBase : null));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking();
        this.Remarks = jsonableObservable(S.value<string | null>(data && data.Remarks !== undefined ? data.Remarks : null));
        this.Start = data && data.Start !== undefined ? new ScheduleDate(data.Start) : new ScheduleDate();
        this.StartTimeConfirmed = jsonableObservable(S.value<boolean>(data && data.StartTimeConfirmed !== undefined ? data.StartTimeConfirmed : false));
        this.UserPreferencesUrlBase = jsonableObservable(S.value<string | null>(data && data.UserPreferencesUrlBase !== undefined ? data.UserPreferencesUrlBase : null));
    }

    static key(obj : PilotJobOrder) {
        return obj.Id();
    }
    
    static dataKey(obj : PilotJobOrderOptions) {
        return obj.Id;
    }

    static update(obj : PilotJobOrder, data : PilotJobOrderOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.FromPointId !== undefined) obj.FromPointId(data.FromPointId);
            if (data.LineHandlingCompanyId !== undefined) obj.LineHandlingCompanyId(data.LineHandlingCompanyId);
            if (data.PilotAgencyId !== undefined) obj.PilotAgencyId(data.PilotAgencyId);
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.ToPointId !== undefined) obj.ToPointId(data.ToPointId);
            if (data.TugCompanyId !== undefined) obj.TugCompanyId(data.TugCompanyId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
            if (data.AcknowledgedDate !== undefined) obj.AcknowledgedDate(data.AcknowledgedDate === null ? null : new TZDate(data.AcknowledgedDate));
            if (data.AirDraft !== undefined) NullableMeasurement.update(obj.AirDraft, data.AirDraft);
            if (data.Billable !== undefined) obj.Billable(data.Billable);
            if (data.BillToAddress !== undefined) obj.BillToAddress(data.BillToAddress);
            if (data.BillToAgent !== undefined) obj.BillToAgent(data.BillToAgent);
            if (data.BowThrusterOperational !== undefined) obj.BowThrusterOperational(data.BowThrusterOperational);
            if (data.DeepDraft !== undefined) NullableMeasurement.update(obj.DeepDraft, data.DeepDraft);
            if (data.DeepDraftConfirmed !== undefined) obj.DeepDraftConfirmed(data.DeepDraftConfirmed);
            if (data.End !== undefined) ScheduleDate.update(obj.End, data.End);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.LaborStartTime !== undefined) obj.LaborStartTime(data.LaborStartTime === null ? null : new TZDate(data.LaborStartTime));
            if (data.Length !== undefined) NullableMeasurement.update(obj.Length, data.Length);
            if (data.NumberOfTugs !== undefined) obj.NumberOfTugs(data.NumberOfTugs);
            if (data.PilotsUrlBase !== undefined) obj.PilotsUrlBase(data.PilotsUrlBase);
            if (data.QBTracking !== undefined) QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
            if (data.Remarks !== undefined) obj.Remarks(data.Remarks);
            if (data.Start !== undefined) ScheduleDate.update(obj.Start, data.Start);
            if (data.StartTimeConfirmed !== undefined) obj.StartTimeConfirmed(data.StartTimeConfirmed);
            if (data.UserPreferencesUrlBase !== undefined) obj.UserPreferencesUrlBase(data.UserPreferencesUrlBase);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotJobOrder.ts